/**
 * Rewrite Cloudflare R2 public URLs through the same-origin image proxy.
 * Direct public-host loads fail CORS, and the bucket CORS cannot be set
 * with the current storage token. The proxy URL never carries a session token.
 * Already-proxied URLs are returned unchanged so a second pass does not wrap them.
 */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== 'string') return url;
  if (url.includes('/api/media/proxy')) return url;
  if (url.includes('/profile_photos/')) return '';
  if (url.includes('/shift_photos/')) return '';
  const isR2 =
    url.includes('.r2.dev/') || url.includes('.r2.cloudflarestorage.com/');
  if (!isR2) return url;

  const base = process.env.REACT_APP_BACKEND_URL || '';
  const params = new URLSearchParams({ url });
  return `${base}/api/media/proxy?${params.toString()}`;
}
